<spark-header
	*ngIf="!publicView; else publicNavbar"
	class="w-100"
>
	<div class="header-brand-controls">
		<!-- Sidebar toggle button -->
		<button
			type="button"
			class="sidebar-toggle d-flex header-icon-button"
			aria-label="Toggle navigation"
			title="Toggle navigation"
			(click)="sidebarNavigationService.toggleSidebar()"
		>
			<ng-fa-icon
				class="align-self-center d-inline-flex"
				icon="bars"
				[size]="EnumNgFaSize.SizeXL"
			></ng-fa-icon>
		</button>
		<app-update-badge></app-update-badge>
	</div>

	<!-- Header Controls -->
	<div class="navbar-collapse collapse header-controls">
		<ul class="navbar-nav ms-auto align-items-center">
			<!-- Birthday Mascot -->
			<li class="header-secondary header-mascot">
				<div class="birthday-mascot-position">
					<app-event-banner></app-event-banner>
				</div>
			</li>

			<!-- What's New? -->
			<li
				class="nav-item my-auto header-secondary"
				*ngIf="IS_WHATS_NEW_ENABLED"
			>
				<h6
					class="mb-0 mt-1 text-white text-center fw-normal"
					(click)="openWhatsNewStatus()"
					[class.pulse]="highlightWhatsNew"
					role="button"
				>
					What's New? 😍
				</h6>
			</li>

			<!-- Tool Toggle -->
			<li class="nav-item my-auto app-switcher-item">
				<button
					type="button"
					class="app-switcher"
					[class.app-switcher--research]="toggleAppTool === EnumWebAppTool.Research"
					[class.app-switcher--upload]="toggleAppTool === EnumWebAppTool.Upload"
					id="{{ EnumResearchTourElement.AppToggleBtn }}"
					[attr.aria-label]="'Switch to Flying ' + toggleAppLabel"
					[title]="'Switch to Flying ' + toggleAppLabel"
					(click)="toggleTool()"
				>
					<img
						class="app-switcher-logo"
						[src]="toggleAppLogo"
						width="24"
						height="24"
						alt=""
						aria-hidden="true"
					/>
					<span class="app-switcher-copy">
						<span>Switch to</span>
						<strong>{{ toggleAppLabel }}</strong>
					</span>
				</button>
			</li>

			<!-- Component for zooming -->
			<app-scale-layout class="fa-icon header-secondary"></app-scale-layout>

			<!-- Dark mode -->
			<ui-dark-mode></ui-dark-mode>

			<!-- Report bug -->
			<li class="nav-item my-auto header-report-item">
				<button
					type="button"
					class="nav-link header-icon-button"
					aria-label="Report a bug"
					title="Report a bug"
					(click)="reportBug()"
				>
					<ng-fa-icon
						class="fa-icon align-middle d-inline-flex"
						icon="bug"
					></ng-fa-icon>
				</button>
			</li>

			<!-- Full Screen -->
			<ui-fullscreen
				*ngIf="isFullScreenEnabled"
				@appearancePreferenceVisibility
			></ui-fullscreen>

			<!-- Store -->
			<li class="nav-item my-auto header-store-item">
				<a
					class="nav-link align-middle header-store-link"
					routerLink="/store/research"
					aria-label="Open store"
					title="Store"
				>
					<ng-fa-icon
						class="fa-icon align-middle d-inline-flex"
						icon="cart-shopping"
					></ng-fa-icon>
					<span class="align-middle fw-normal ms-2 header-store-label">Store</span>
				</a>
			</li>

			<!-- FLAI -->
			<li class="nav-item my-auto agent-launcher-item">
				<button
					#agentLauncher
					type="button"
					class="nav-link header-icon-button agent-launcher"
					[class.agent-launcher--active]="agentPanelOpen"
					[class.agent-launcher--research]="toggleAppTool === EnumWebAppTool.Upload"
					[class.agent-launcher--upload]="toggleAppTool === EnumWebAppTool.Research"
					[attr.aria-expanded]="agentPanelOpen"
					aria-controls="flying-agent-panel"
					[attr.aria-label]="agentPanelOpen ? 'Close FLAI' : 'Open FLAI'"
					[title]="agentPanelOpen ? 'Close FLAI' : 'Open FLAI'"
					(click)="agentPanelToggle.emit()"
				>
					<ng-fa-icon
						class="agent-launcher-mark"
						icon="sparkles"
						aria-hidden="true"
					></ng-fa-icon>
				</button>
			</li>

			<!-- Settings Menu -->
			<li
				class="nav-item my-auto"
				ngbDropdown
				placement="auto"
				container="body"
				display="dynamic"
			>
				<button
					type="button"
					class="nav-link dropdown-toggle position-relative header-icon-button header-account-button"
					ngbDropdownToggle
					id="userSettings"
					aria-label="Open account menu"
					title="Account menu"
				>
					<img
						class="header-account-avatar"
						[src]="userInfo.avatarImage || ('assets/shared/profile/profile' + userInfo.avatar + '.jpg')"
						[alt]="userInfo.firstname ? userInfo.firstname + ' profile avatar' : 'Profile avatar'"
					/>
				</button>
				<div
					ngbDropdownMenu
					aria-labelledby="userSettings"
					class="dropdown-menu dropdown-menu-end header-account-menu"
				>
					<!-- Tokens Info -->
					<div
						ngbDropdownItem
						disabled
					>
						<ng-fa-icon
							class="align-middle me-1 d-inline-flex text-warning"
							icon="coins"
						></ng-fa-icon>
						<span class="text-primary">Tokens:</span>
						<span class="text-primary fw-bolder">
							{{ tokensBalance | number }}
						</span>
					</div>

					<!-- Add Tokens -->
					<div class="px-2 py-1">
						<button
							type="button"
							routerLink="/store/research"
							[queryParams]="{ addTokens: true }"
							class="btn token-btn text-white d-flex w-100 align-items-center justify-content-center border-0"
						>
							<ng-fa-icon
								class="align-middle me-1 d-inline-flex"
								icon="wallet"
							></ng-fa-icon>
							<span>Add Tokens</span>
						</button>
					</div>
					<div class="dropdown-divider"></div>

					<!-- Settings -->
					<a
						ngbDropdownItem
						href="#"
						(click)="$event.preventDefault()"
						routerLink="/settings/appearance"
					>
						<ng-fa-icon
							class="align-middle me-1 d-inline-flex"
							icon="gears"
						></ng-fa-icon>
						Settings
					</a>
					<a
						ngbDropdownItem
						[href]="DISCORD_URL"
						target="_blank"
					>
						<ng-fa-icon
							class="align-middle me-1 d-inline-flex"
							icon="discord"
							iconStyle="brands"
						></ng-fa-icon>
						Discord Server
					</a>
					<a
						ngbDropdownItem
						href="javascript:void(0);"
						(click)="openWelcomeTour()"
					>
						<ng-fa-icon
							class="align-middle me-1 d-inline-flex"
							icon="circle-play"
						></ng-fa-icon>
						Welcome Tour
					</a>
					<button
						ngbDropdownItem
						type="button"
						(click)="reportBug()"
					>
						<ng-fa-icon
							class="align-middle me-1 d-inline-flex"
							icon="bug"
						></ng-fa-icon>
						Report a bug
					</button>
					<div class="dropdown-divider"></div>
					<a
						ngbDropdownItem
						[href]="AFFILIATE_PROGRAM"
						target="_blank"
					>
						<ng-fa-icon
							class="align-middle me-1 d-inline-flex"
							icon="users"
						></ng-fa-icon>
						Affiliate
					</a>

					<div class="dropdown-divider"></div>

					<button
						ngbDropdownItem
						type="button"
						(click)="signOut()"
						[disabled]="isSigningOut"
						[attr.aria-busy]="isSigningOut"
					>
						<span
							*ngIf="isSigningOut"
							class="spinner-border spinner-border-sm align-middle me-2"
							aria-hidden="true"
						></span>
						<ng-fa-icon
							*ngIf="!isSigningOut"
							class="align-middle me-1 d-inline-flex"
							icon="right-from-bracket"
						></ng-fa-icon>
						{{ isSigningOut ? 'Signing out...' : 'Sign out' }}
					</button>
				</div>
			</li>
		</ul>
	</div>
</spark-header>

<ng-template #publicNavbar>
	<spark-header class="w-100 public-header">
		<a
			class="public-header-brand"
			routerLink="/"
			aria-label="Flying Research dashboard"
		>
			<img
				src="assets/research/logos/research-logo-wide.svg"
				alt="Flying Research"
			/>
		</a>
		<nav
			class="public-header-actions"
			aria-label="Webapp navigation"
		>
			<a
				class="btn btn-default public-header-store d-none d-sm-inline-flex"
				routerLink="/store/research"
			>
				Store
			</a>
			<ui-dark-mode appearance="toggle"></ui-dark-mode>
			<a
				class="btn btn-primary public-header-return"
				[routerLink]="returnUrl"
			>
				<ng-fa-icon
					icon="arrow-left"
					aria-hidden="true"
				></ng-fa-icon>
				<span>Go back</span>
			</a>
		</nav>
	</spark-header>
</ng-template>
